module.exports = __webpack_public_path__ + "static/img/ic_calculator@2x.203bd34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_calculator@2x.png
// module id = RTNH
// module chunks = 1